import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import englishFlag from '../../images/english.png';
import finnishFlag from '../../images/finnish.png';
import swedishFlag from '../../images/swedish.png';

const flagStyle = {
    width: '35px', // Adjust the width of the flags as needed
    height: 'auto', // Maintain aspect ratio
    marginRight: '5px', // Add space between flags
    marginTop: '15px'
  };

function TranslatorComponent() {
  const { t, i18n } = useTranslation();

  const changeLanguage = (lng) => {
    window.location.reload();
    localStorage.setItem('defaultLanguage', lng);
    i18n.changeLanguage(lng);
  };

  return (
    <div>
      <img src={englishFlag} alt="English" style={flagStyle} onClick={() => changeLanguage('en')} />
      <img src={finnishFlag} alt="Finnish" style={flagStyle} onClick={() => changeLanguage('fi')} />
      <img src={swedishFlag} alt="Swedish" style={flagStyle} onClick={() => changeLanguage('swe')} />
    </div>
  );
}

export default TranslatorComponent;

